// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
This style file is imported by Updatedtime.js which is called by Home.js file, CsVersionTable.js file, PltVersionTable.js file.
*/

.time-display {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  font-family: 'Poppins', sans-serif;
  font-size: 16px;
  margin: 0;
  color: #0C3135;
  height: 2.5rem;
}

.time {
  display: inline-flex;
  align-items: center;
  background-color: #0C3135;
  border-radius: 8px;
  font-weight: lighter;
  font-size: 14px;
  color: white;
  text-align: center;
  padding: 0.5rem 1rem;
  margin-left: 0.5rem;
  height: 1.0rem;
}
/* For screens up to 320px */
@media (max-width: 321px) {
  .updatedtime h4 {
    font-size: 14px;
  }
  .time {
    height: 3.0rem;
    width: 5.0rem;
    padding: 0;
  }
}

/* For screens between 321px and 375px */
@media (min-width: 321px) and (max-width: 376px) {
  .updatedtime h4 {
    font-size: 14px;
  }
  .time {
    height: 2.0rem;
    width: 8.0rem;
    padding: 0;
  }
}

/* For screens between 376px and 426px */
@media (min-width: 376px) and (max-width: 426px) {
  .updatedtime h4 {
    font-size: 14px;
  }
  .time {
    height: 2.0rem;
    width: 11.0rem;
    padding: 0;
  }
}

@media (min-width: 426px) and (max-width: 769px) {
  .updatedtime h4 {
    font-size: 14px;
  }
  .time {
    height: 2.0rem;
    width: 11.0rem;
    padding: 0;
  }
}

@media (min-width: 769px) and (max-width: 1025px) {
  .updatedtime h4 {
    font-size: 16px;
  }
  .time {
    height: 2vh;
    width:  17vw;
  }
}

@media (min-width: 1025px) and (max-width: 1441px) {
  .updatedtime h4 {
    font-size: 20px;
  }
  .time {
    height: 2vh;
    width:  12vw;
  }
}

`, "",{"version":3,"sources":["webpack://./src/components/UpdatedTime/Updatedtime.css"],"names":[],"mappings":"AAAA;;CAEC;;AAED;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kCAAkC;EAClC,eAAe;EACf,SAAS;EACT,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;AAChB;AACA,4BAA4B;AAC5B;EACE;IACE,eAAe;EACjB;EACA;IACE,cAAc;IACd,aAAa;IACb,UAAU;EACZ;AACF;;AAEA,wCAAwC;AACxC;EACE;IACE,eAAe;EACjB;EACA;IACE,cAAc;IACd,aAAa;IACb,UAAU;EACZ;AACF;;AAEA,wCAAwC;AACxC;EACE;IACE,eAAe;EACjB;EACA;IACE,cAAc;IACd,cAAc;IACd,UAAU;EACZ;AACF;;AAEA;EACE;IACE,eAAe;EACjB;EACA;IACE,cAAc;IACd,cAAc;IACd,UAAU;EACZ;AACF;;AAEA;EACE;IACE,eAAe;EACjB;EACA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE;IACE,eAAe;EACjB;EACA;IACE,WAAW;IACX,YAAY;EACd;AACF","sourcesContent":["/*\nThis style file is imported by Updatedtime.js which is called by Home.js file, CsVersionTable.js file, PltVersionTable.js file.\n*/\n\n.time-display {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  font-family: 'Poppins', sans-serif;\n  font-size: 16px;\n  margin: 0;\n  color: #0C3135;\n  height: 2.5rem;\n}\n\n.time {\n  display: inline-flex;\n  align-items: center;\n  background-color: #0C3135;\n  border-radius: 8px;\n  font-weight: lighter;\n  font-size: 14px;\n  color: white;\n  text-align: center;\n  padding: 0.5rem 1rem;\n  margin-left: 0.5rem;\n  height: 1.0rem;\n}\n/* For screens up to 320px */\n@media (max-width: 321px) {\n  .updatedtime h4 {\n    font-size: 14px;\n  }\n  .time {\n    height: 3.0rem;\n    width: 5.0rem;\n    padding: 0;\n  }\n}\n\n/* For screens between 321px and 375px */\n@media (min-width: 321px) and (max-width: 376px) {\n  .updatedtime h4 {\n    font-size: 14px;\n  }\n  .time {\n    height: 2.0rem;\n    width: 8.0rem;\n    padding: 0;\n  }\n}\n\n/* For screens between 376px and 426px */\n@media (min-width: 376px) and (max-width: 426px) {\n  .updatedtime h4 {\n    font-size: 14px;\n  }\n  .time {\n    height: 2.0rem;\n    width: 11.0rem;\n    padding: 0;\n  }\n}\n\n@media (min-width: 426px) and (max-width: 769px) {\n  .updatedtime h4 {\n    font-size: 14px;\n  }\n  .time {\n    height: 2.0rem;\n    width: 11.0rem;\n    padding: 0;\n  }\n}\n\n@media (min-width: 769px) and (max-width: 1025px) {\n  .updatedtime h4 {\n    font-size: 16px;\n  }\n  .time {\n    height: 2vh;\n    width:  17vw;\n  }\n}\n\n@media (min-width: 1025px) and (max-width: 1441px) {\n  .updatedtime h4 {\n    font-size: 20px;\n  }\n  .time {\n    height: 2vh;\n    width:  12vw;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
